import { FormFieldsProps } from "../../../interfaces/ISginUpSignInForm";
import { Grid, TextField } from "@mui/material";

export default function FormFields({
  fieldsList,
  formData,
  formErrors,
  onChange,
  fieldDirection,
}: FormFieldsProps) {
  return (
    <form>
      <Grid container spacing={2} direction={fieldDirection}>
        {fieldsList.map((field) => (
          <Grid item xs={12} sm={6} key={field.name}>
            <TextField
              fullWidth
              label={field.label}
              name={field.name}
              type={field.type}
              required={field.required}
              value={formData[field.name]}
              onChange={onChange}
              helperText={formErrors[field.name]}
              error={!!formErrors[field.name]}
              size="small"
              inputProps={{
                autoComplete: field.autocomplete || "off",
              }}
            />
          </Grid>
        ))}
      </Grid>
    </form>
  );
}
